exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".title-d76fa{font-size:21px}", ""]);

// Exports
exports.locals = {
	"title": "title-d76fa"
};